import { Box, Typography } from "@mui/material";
import { useRTL } from "hooks/isRTL";
import CustomerTable from "../../Components/CustomerManagement/CustomerTable";

const CustomerManagement = () => {
  const { t } = useRTL();
  return (
    <Box
      sx={{
        padding: "3.2rem 4.5rem",
        height: "100%",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h1">{t("customerManagement")}</Typography>
      </Box>
      <CustomerTable />
    </Box>
  );
};

export default CustomerManagement;
